import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';

import {catchError, concatMap, map, mergeMap, switchMap} from 'rxjs/operators';
import {of} from 'rxjs';

import * as RegisterActions from '../actions/register.actions';
import {AuthenticateService} from '../../authenticate.service';
import {CognitoService} from '../../../cognito.service';


@Injectable()
export class RegisterEffects {

  constructor(private actions$: Actions,
              private authenticateService: AuthenticateService,
              private cognitoService: CognitoService
  ) {
  }

  // registerUser$ = createEffect(() => {
  //   return this.actions$.pipe(
  //     ofType(RegisterActions.registerNewUser),
  //     switchMap(action => {
  //       return this.authenticateService.registerUser(action.registerFrom).pipe(
  //         map((res: any) => {
  //           if (res.code === 200) {
  //             this.authenticateService.activateAccount(action.registerFrom);
  //             // check if the above succeeded or failed
  //
  //             return RegisterActions.registerNewUserSuccess();
  //           }
  //           return RegisterActions.registerNewUserFailed({code: res.code, error: res.data});
  //         })
  //       );
  //     })
  //   );
  // });

  registerUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RegisterActions.registerNewUser),
      switchMap(action => {
        return this.cognitoService.signUp(action.registerFrom).pipe(
          mergeMap((res: any) => {
            if (res?.user?.username) {
              return this.authenticateService.registerUser(action.registerFrom).pipe(
                map((resLocal: any) => {
                  if (resLocal.code === 200) {
                    // this.authenticateService.activateAccount(action.registerFrom);
                    // check if the above succeeded or failed
                    return RegisterActions.registerNewUserPreConfirm({code: resLocal.code, error: res.data});
                  }
                  return RegisterActions.registerNewUserFailed({code: resLocal.code, error: res.data});
                }),
                catchError((e) => {
                  return of(RegisterActions.registerNewUserFailed({code: 500, error: e}));
                })
              );
            }
            return of(RegisterActions.registerNewUserFailed({code: res.code, error: res.data}));
          }),
          catchError((e) => {
            if (e.code === 'UsernameExistsException')
            {  return of(RegisterActions.registerNewUserFailed({code: 311, error: e.message})); }
            else if (e.code === 'InvalidPasswordException')
            {  return of(RegisterActions.registerNewUserFailed({code: 312, error: e.message})); }
            return of(RegisterActions.registerNewUserFailed({code: 500, error: e}));
          })
        );
      })
    );
  });

  confirmUser$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RegisterActions.registerNewUserConfirm),
      switchMap(action => {
        return this.cognitoService.confirmSignUp(action.registerForm).pipe(
          mergeMap((res) => {
            if (res === 'SUCCESS') {
              return this.cognitoService.signIn(action.registerForm).pipe(
                mergeMap((resLocal: any) => {
                  if (resLocal?.attributes?.email_verified && resLocal?.signInUserSession?.accessToken?.jwtToken) {
                    sessionStorage.setItem('token', resLocal.signInUserSession.accessToken.jwtToken);
                    return this.authenticateService.activateAccount(
                      resLocal.signInUserSession.idToken
                      // resLocal?.signInUserSession?.accessToken?.jwtToken,
                      // action.registerForm.email,
                      // resLocal?.username
                    ).pipe(
                      map((res: any) => {
                        if (res.code === 200) {
                          // sessionStorage.setItem('token', resLocal.signInUserSession.accessToken.jwtToken);
                          return RegisterActions.registerNewUserSuccess();
                        }
                        return RegisterActions.registerNewUserFailed({code: -1, error: ''});
                      })
                    );
                  }
                  return of(RegisterActions.registerNewUserFailed({code: -1, error: ''}));
                })
              );
            }
            return of(RegisterActions.registerNewUserFailed({code: -1, error: ''}));
          }),
        );
      })
    );
  });

  loadRegisters$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(RegisterActions.loadRegisters),
      /** An EMPTY observable only emits completion. Replace with your own observable API request */
      concatMap(() => [])
    );
  });

}


